module.exports = __webpack_public_path__ + "img/soujiu.c563bfaa.jpg";